// src/pages/PendingTeachers.js

import React, { useState, useEffect } from 'react';
import { getPendingTeachers } from '../../firebase_config';
import TeacherList from '../../components/teachers/TeacherList';
import DashboardLayout from '../../components/layout/DashboardLayout';
import { Box, CircularProgress, Alert } from '@mui/material';

const PendingTeachers = () => {
    const [teachers, setTeachers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchTeachers = async () => {
            try {
                const result = await getPendingTeachers();
                setTeachers(result.data);
            } catch (err) {
                setError(err.message || 'Failed to fetch pending teachers.');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchTeachers();
    }, []);

    return (
        <DashboardLayout title="Pending Teacher Applications">
            {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                    <CircularProgress />
                </Box>
            ) : error ? (
                <Alert severity="error">{error}</Alert>
            ) : (
                // The onUpdate prop has been removed as it was unused.
                <TeacherList teachers={teachers} />
            )}
        </DashboardLayout>
    );
};

export default PendingTeachers;